import style from "./SearchTopBarItem.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import clsx from "classnames";
import VerticalMiddleWrapper from "layouts/wrapper/VerticalMiddleWrapper";
import Inline from "layouts/container/Inline";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SearchReducer } from "shared/redux/reducers/search/SearchReducer";


function SearchTopBarItem(props) {
  const dispatch = useDispatch();
  const { isSearchOpen } = useSelector((state) => state.search);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const inputRef = useRef(null);  // input 요소를 참조하기 위한 ref 추가

  // 검색창 토글
  // const toggleSearch = () => {
  //   if (isSearchOpen && !searchText) {
  //     // 검색창이 열려 있고 입력값이 비어있다면 닫음
  //     setIsSearchOpen(false);
  //   } else if (searchText) {


  //     navigate(`/productList/category/find`, { state: { search: searchText } });
  //   } else {
  //     // 검색창 열기
  //     setIsSearchOpen(true);
  //   }
  // };

  useEffect(() => {
    if (isSearchOpen && inputRef.current) {
      // 약간의 지연을 주어 애니메이션이 시작된 후 포커스
      const timeoutId = setTimeout(() => {
        inputRef.current.focus();
      }, 100);  // 100ms 후에 포커스

      return () => clearTimeout(timeoutId);
    }
  }, [isSearchOpen]);

  const handleSearch = () => {
    if (isSearchOpen && searchText) {
      navigate(`/productList/category/find`, { state: { search: searchText } });
      dispatch(SearchReducer.actions.closeSearch());
      setSearchText("");
    } else {
      dispatch(SearchReducer.actions.toggleSearch());
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && searchText) {
      handleSearch();
    }
  };


  // 입력값 핸들러
  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <li className={style.column}>
      <div className={style.topBarItem}>
        <Inline>
          <input
            ref={inputRef}  // ref 연결
            type="text"
            placeholder="상품명"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            className={clsx(style.searchInput, {
              [style.active]: isSearchOpen,
            })}
          />
          <FontAwesomeIcon
            icon={faSearch}
            color={isSearchOpen ? "var(--main-color)" : "black"}
            onClick={handleSearch}
            className={style.searchIcon}
          />
        </Inline>
      </div>
    </li>
    // <li className={style.column}>
    //   {/* <VerticalMiddleWrapper> */}
    //   <div className={style.topBarItem}>
    //     <Inline>
    //       {/* 검색 input */}
    //       <input
    //         type="text"
    //         placeholder="상품명"
    //         value={searchText}
    //         onChange={handleInputChange}
    //         onKeyDown={handleKeyDown}
    //         className={clsx(style.searchInput, {
    //           [style.active]: isSearchOpen,
    //         })}
    //       />
    //       {/* 검색 아이콘 */}
    //       <FontAwesomeIcon
    //         icon={faSearch}
    //         color={isSearchOpen ? "var(--main-color)" : "black"}
    //         onClick={toggleSearch}
    //         className={style.searchIcon}
    //       />
    //     </Inline>
    //   </div>
    //   {/* </VerticalMiddleWrapper> */}
    // </li>
  );
}

export default SearchTopBarItem;
